import type { ReactNode } from "react";
import type { IFlightScheduleChangeModalData } from "@tenant/flights";
import { Button, ButtonTypeEnum } from "@tenant/ui";

export interface IFlightScheduleChangeAcceptSuccessProps {
  classNames?: Partial<{
    contentBody: string;
    contentHeader: string;
    contentSubtitle: string;
    contentTitle: string;
    doneBtn: string;
    root: string;
    successImage: string;
  }>;
  scheduleChangeDataModel: IFlightScheduleChangeModalData;
  successImage?: ReactNode;
}

export const FlightScheduleChangeAcceptSuccess = (
  props: IFlightScheduleChangeAcceptSuccessProps
) => {
  const {
    classNames,
    scheduleChangeDataModel: { handlers, text },
    successImage,
  } = props;

  return (
    <div className={classNames?.root}>
      <div className={classNames?.contentHeader}>
        <span className={classNames?.contentTitle}>
          {text.acceptSuccess.title}
        </span>
        <span className={classNames?.contentSubtitle}>
          {text.acceptSuccess.body}
        </span>
      </div>
      <div className={classNames?.contentBody}>
        {successImage == null ? null : (
          <div className={classNames?.successImage}>{successImage}</div>
        )}
        <Button
          buttonType={ButtonTypeEnum.Primary}
          className={classNames?.doneBtn}
          onClick={handlers.closeModal}
        >
          {text.acceptSuccess.doneBtn}
        </Button>
      </div>
    </div>
  );
};
